import React from "react";
import ErrorBoundary from "components/ErrorBoundary";
import {
  MosaicLayout,
  MosaicLayoutProps
} from "@silversea-ssc/ui-components-react";
import OfferTokenizedContent from "components/OfferTokenizedContent/OfferTokenizedContent";
import { LocationSpecificOffer } from "components/useLocationSpecificOffers/types";
import LinkCard from "components/Card/LinkCard";
import { cardImageRatioForMosaicIndex } from "@silversea-ssc/ui-components-react";

export interface OffersMosaicProps extends MosaicLayoutProps {
  data: LocationSpecificOffer[];
}

export const OffersMosaic: React.FC<OffersMosaicProps> = (props) => {
  const { data, ...otherProps } = props;

  return (
    <ErrorBoundary>
      <MosaicLayout {...otherProps} data-content-name="offers_mosaic">
        {data?.map((item, index) => {
          const cardRatio = cardImageRatioForMosaicIndex(props.variant, index);
          return (
            <LinkCard
              key={item.sanityId}
              backgroundColor="white"
              trackingName={item.trackName}
              image={item.cardContent?.image}
              imageRatio={cardRatio}
              title={
                <OfferTokenizedContent
                  content={item.cardContent?.title}
                  tokenValues={item.tokenValues}
                />
              }
              description={
                <OfferTokenizedContent
                  content={item.cardContent?.description}
                  tokenValues={item.tokenValues}
                />
              }
              url={item.fullPath}
            />
          );
        })}
      </MosaicLayout>
    </ErrorBoundary>
  );
};
